import React from 'react';
import './App.css';
import routes from './views/routes'
import { Switch, Route } from 'react-router-dom';

function App() {
  return (
   <Switch>
     {routes.map((el, idx) => <Route
       key={idx}
       path={el.path}
       component={el.component}
       exact={true}
     />)}
   </Switch>
  );
}

export default App;
